import React from 'react'
import { useParams } from 'react-router-dom'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SupplyBillView from './view/SupplyBillView'

const SupplyBill = () => {

    const { supplyBillId } = useParams()

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Рахунок № ' + supplyBillId}
            isBack={true}
            // options={
            //     <SupplyOrderOptions />
            // }
        />
		<MyBlock>
			<SupplyBillView 
				supplyBillId={supplyBillId}
			/>
		</MyBlock>
    </LayoutMain>
  )
}

export default SupplyBill